/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Logger = void 0;
const path_1 = __importDefault(__webpack_require__(606));
const SPACER = ", ";
const LEVELS = [
    "info",
    "log",
    "deprecated",
    "warn",
    "error",
    "disable",
];
;
;
let smashLogger;
if (!smashLogger) {
    const verbose = {};
    smashLogger = { verbose };
}
if (!smashLogger.verbose) {
    const verbose = {};
    smashLogger.verbose = verbose;
}
function stack() {
    const prepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = (_, stack) => stack;
    const stack = (new Error().stack).filter(s => !!s.getFileName());
    while (stack[0].getFileName().indexOf("smash-logger") >= 0) {
        stack.shift();
    }
    Error.prepareStackTrace = prepareStackTrace;
    return stack;
}
function lastFileName() {
    const [file] = stack();
    return file.getFileName();
}
function getNamespace() {
    if ('basename' in path_1.default && 'extname' in path_1.default) {
        const file = lastFileName();
        const namespace = path_1.default.basename(file, path_1.default.extname(file));
        return namespace[0].toUpperCase() + namespace.slice(1);
    }
    else {
        return "";
    }
}
class Logger {
    constructor(namespace = getNamespace(), verbose) {
        this.namespace = namespace;
        this.verbose = smashLogger.verbose;
        if (verbose) {
            this.verbose = verbose;
        }
    }
    static verbose(options = {}) {
        smashLogger.verbose = options;
        return this;
    }
    typeOf(...args) {
        return args.map(arg => {
            if (arg && typeof arg === "object") {
                return "type " + typeof arg + " / class " + arg.constructor.name + " given";
            }
            return "type " + typeof arg + " given";
        }).join(SPACER);
    }
    buildError(message, code) {
        const error = new Error(message);
        if (code) {
            error.statusCode = code;
        }
        return error;
    }
    setVerbose(options = {}) {
        this.verbose = options;
        return this;
    }
    setNamespace(namespace) {
        this.namespace = namespace;
        return this;
    }
    getPrefix(level) {
        if (this.namespace && level) {
            return this.namespace + " " + level + ": ";
        }
        if (this.namespace) {
            return this.namespace + ": ";
        }
        if (level) {
            return level + ": ";
        }
        return "";
    }
    isVerbose(level) {
        if (this.verbose.level) {
            if (LEVELS.indexOf(level) >= LEVELS.indexOf(this.verbose.level)) {
                return true;
            }
            return false;
        }
        if (this.verbose[level] !== false) {
            return true;
        }
        return false;
    }
    print(...args) {
        console.log(...args);
    }
    deprecated(...args) {
        if (this.isVerbose("deprecated")) {
            console.log(this.getPrefix("deprecated"), ...args);
        }
    }
    log(...args) {
        if (this.isVerbose("log")) {
            console.log(this.getPrefix(), ...args);
        }
    }
    debug(...args) {
        console.debug(this.getPrefix(), ...args);
    }
    info(...args) {
        if (this.isVerbose("info")) {
            console.info(this.getPrefix(), ...args);
        }
    }
    warn(...args) {
        if (this.isVerbose("warn")) {
            console.warn(this.getPrefix(), ...args);
        }
    }
    error(...args) {
        if (this.isVerbose("error")) {
            console.error(this.getPrefix(), ...args);
        }
    }
    table(...args) {
        console.table(...args);
    }
    time(...args) {
        console.time(...args);
    }
    timeEnd(...args) {
        console.timeEnd(...args);
    }
    timeLog(...args) {
        console.timeLog(...args);
    }
    trace(...args) {
        console.trace(...args);
    }
}
exports.Logger = Logger;


/***/ }),

/***/ 606:
/***/ (() => {

/* (ignored) */

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(607);
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;
